(() => {
  const NAV_LINK_SELECTOR =
  '.header__inline-menu a[href], .menu-drawer__navigation a[href], .header__text-link--cart[href]';

  let controller;
let layoutObserver;
let frameRequested = false;

  const normalizePath = (path) => {
    const normalized = path.replace(/\/+$/, '');
    return normalized || '/';
  };

  const getLinkUrl = (link) => {
    try {
      return new URL(
        link.getAttribute('href'),
        window.location.href
      );
    } catch (error) {
      return null;
    }
  };

  const getLinkLabel = (link) =>
    link.textContent
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  const closeMobileDrawer = () => {
    const openDrawer = document.querySelector(
      'header-drawer details[open]'
    );

    const summary = openDrawer?.querySelector(
      ':scope > summary'
    );

    if (summary) {
      summary.click();
    }
  };

  const initializePageNavigation = () => {
  controller?.abort();
  layoutObserver?.disconnect();

  controller = new AbortController();
  layoutObserver = null;
  frameRequested = false;

    const { signal } = controller;

    const headerSection =
      document.querySelector('.section-header');

    const contactSection =
      document.getElementById('contact');

    const navLinks = [
      ...document.querySelectorAll(NAV_LINK_SELECTOR),
    ];

    if (!headerSection || navLinks.length === 0) {
      return;
    }

    const currentPath = normalizePath(
      window.location.pathname
    );

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    const scrollBehavior = reducedMotion
      ? 'auto'
      : 'smooth';

    /*
     * Identify Contact by its visible menu label as well
     * as by its #contact destination.
     */
    const contactLinks = navLinks.filter((link) => {
      const url = getLinkUrl(link);

      return (
        getLinkLabel(link) === 'contact' ||
        url?.hash.toLowerCase() === '#contact'
      );
    });

    /*
     * Find the normal menu item representing the page
     * currently being viewed. Compare paths rather than
     * requiring the domains to match.
     */
    let currentPageLinks = navLinks.filter((link) => {
      const url = getLinkUrl(link);

      return Boolean(
        url &&
          !url.hash &&
          normalizePath(url.pathname) === currentPath &&
          !contactLinks.includes(link)
      );
    });

    /*
     * Fallback for Home and About in case the Shopify
     * theme editor changes how the menu URLs are rendered.
     */
    if (currentPageLinks.length === 0) {
      let expectedLabel = null;

      if (currentPath === '/') {
        expectedLabel = 'home';
      } else if (currentPath.includes('/pages/about')) {
        expectedLabel = 'about';
      }

      if (expectedLabel) {
        currentPageLinks = navLinks.filter(
          (link) => getLinkLabel(link) === expectedLabel
        );
      }
    }
      /*
 * Keep Catalog active on collection pages and
 * establish Catalog + All as the product-page baseline.
 */
const catalogMenu = document.querySelector(
  '.pk-catalog-menu'
);

const catalogLink = catalogMenu?.querySelector(
  '.pk-catalog-menu__link'
);

const catalogChildLinks = catalogMenu
  ? [
      ...catalogMenu.querySelectorAll(
        '.pk-catalog-menu__submenu a[href]'
      ),
    ]
  : [];

const isProductPage =
  /^\/products\/[^/]+$/.test(currentPath);

/*
 * Index the visible Catalog children by their
 * collection handles: all, necklaces, bracelets,
 * earrings, and rings.
 */
const catalogChildLinksByHandle =
  new Map();

catalogChildLinks.forEach((link) => {
  const url = getLinkUrl(link);

  const match =
    url && !url.hash
      ? normalizePath(url.pathname).match(
          /^\/collections\/([^/]+)$/
        )
      : null;

  const handle = match?.[1] ?? null;

  if (handle) {
    catalogChildLinksByHandle.set(
      handle,
      link
    );
  }
});

const isKnownCatalogHandle = (handle) =>
  typeof handle === 'string' &&
  catalogChildLinksByHandle.has(handle);

/*
 * Product pages default to All.
 *
 * A valid collection fragment takes priority.
 * After reading it, preserve the collection on
 * this history entry and restore the clean URL.
 *
 * On later loads of the same history entry,
 * restore its saved collection context.
 */
let productCollectionHandle = 'all';

if (isProductPage) {
  const fragmentMatch =
    window.location.hash.match(
      /^#pk-collection=([a-z0-9-]+)$/
    );

  const fragmentHandle =
    fragmentMatch?.[1] ?? null;

  const currentHistoryState =
    window.history.state &&
    typeof window.history.state ===
      'object'
      ? window.history.state
      : {};

  const historyHandle =
    currentHistoryState.pkCollection;

  if (
    isKnownCatalogHandle(
      fragmentHandle
    )
  ) {
    productCollectionHandle =
      fragmentHandle;

    window.history.replaceState(
      {
        ...currentHistoryState,
        pkCollection: fragmentHandle,
      },
      '',
      `${window.location.pathname}${window.location.search}`
    );
  } else if (
    isKnownCatalogHandle(
      historyHandle
    )
  ) {
    productCollectionHandle =
      historyHandle;
  }
}

const productCollectionLink =
  isProductPage
    ? catalogChildLinksByHandle.get(
        productCollectionHandle
      ) ??
      catalogChildLinksByHandle.get(
        'all'
      )
    : null;

const catalogIsCurrent =
  isProductPage ||
  [
    catalogLink,
    ...catalogChildLinks,
  ].some((link) => {
    const url = link
      ? getLinkUrl(link)
      : null;

    return Boolean(
      url &&
        !url.hash &&
        normalizePath(url.pathname) ===
          currentPath
    );
  });

if (
  catalogIsCurrent &&
  catalogLink &&
  !currentPageLinks.includes(catalogLink)
) {
  currentPageLinks.push(catalogLink);
}

if (
  productCollectionLink &&
  !currentPageLinks.includes(
    productCollectionLink
  )
) {
  currentPageLinks.push(
    productCollectionLink
  );
}
    const setActiveLinks = (activeLinks) => {
      navLinks.forEach((link) => {
        link.classList.remove('pk-nav-active');
      });

      activeLinks.forEach((link) => {
        link.classList.add('pk-nav-active');
      });
    };

    const updateActiveLink = () => {
      let contactIsActive = false;

      if (contactSection) {
        const contactRect =
          contactSection.getBoundingClientRect();

        const cssHeaderHeight =
          parseFloat(
            getComputedStyle(
              document.documentElement
            ).getPropertyValue('--header-height')
          ) || 0;

        const headerHeight =
          cssHeaderHeight ||
          headerSection.offsetHeight;

        /*
         * Contact becomes active when the section reaches
         * approximately 45% down the visible screen.
         */
        const activationLine = Math.max(
          headerHeight + 24,
          window.innerHeight * 0.45
        );

        contactIsActive =
          contactRect.top <= activationLine &&
          contactRect.bottom > headerHeight;
      }

      setActiveLinks(
        contactIsActive
          ? contactLinks
          : currentPageLinks
      );
    };

    const scheduleActiveLinkUpdate = () => {
      if (frameRequested) {
        return;
      }

      frameRequested = true;

      window.requestAnimationFrame(() => {
        updateActiveLink();
        frameRequested = false;
      });
    };

    navLinks.forEach((link) => {
      link.addEventListener(
        'click',
        (event) => {
          if (
            event.defaultPrevented ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey
          ) {
            return;
          }

          const url = getLinkUrl(link);

          if (!url) {
            return;
          }

          const isContactLink =
            contactLinks.includes(link);

          /*
           * Scroll to the Contact section on whichever
           * page is currently being viewed.
           */
          if (isContactLink && contactSection) {
            event.preventDefault();
            closeMobileDrawer();

            window.requestAnimationFrame(() => {
              contactSection.scrollIntoView({
                behavior: scrollBehavior,
                block: 'start',
              });
            });

            return;
          }

          /*
           * Clicking Home while on Home, or About while
           * on About, returns to the top of that page.
           */
          const pointsToCurrentPage =
            normalizePath(url.pathname) === currentPath &&
            !url.hash;

          if (pointsToCurrentPage) {
            event.preventDefault();
            closeMobileDrawer();

            window.scrollTo({
              top: 0,
              behavior: scrollBehavior,
            });
          }
        },
        { signal }
      );
    });

    window.addEventListener(
      'scroll',
      scheduleActiveLinkUpdate,
      {
        passive: true,
        signal,
      }
    );

    window.addEventListener(
      'resize',
      scheduleActiveLinkUpdate,
      {
        passive: true,
        signal,
      }
    );

    if ('ResizeObserver' in window) {
  layoutObserver = new ResizeObserver(() => {
    scheduleActiveLinkUpdate();
  });

  layoutObserver.observe(document.body);

  const mainContent =
    document.getElementById('MainContent');

  if (mainContent) {
    layoutObserver.observe(mainContent);
  }
}

    updateActiveLink();
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializePageNavigation,
      { once: true }
    );
  } else {
    initializePageNavigation();
  }

  document.addEventListener(
    'shopify:section:load',
    initializePageNavigation
  );

  document.addEventListener(
    'shopify:section:reorder',
    initializePageNavigation
  );
})();
